import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import OrderConfirmationTable from './components/Table';

import CommonIcons from '../icons/Common';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const OrderConfirmation = ({
	membershipListData,
	submitResult,
	browserResult
}) => {
	const { t } = useTranslation('orderConfirmation');

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'flex-start',
				width: '100%',
				mx: 'auto',
				py: 2,
				px: { xs: 2, md: 4 }
			}}
		>
			<Stack>
				<Typography variant='h5' sx={{ fontWeight: 600, mb: 2 }}>
					{t('orderComplete')}
				</Typography>

				<Stack direction='row' alignItems='center' spacing={1} sx={{ mb: 2 }}>
					<CommonIcons.success />
					<Typography variant='body1'>{t('thankYou')}</Typography>
				</Stack>
				<Typography
					variant='body2'
					color='text.secondary'
					sx={{ mb: 2, maxWidth: 850 }}
				>
					{t('confirmationMessage', {
						membership: membershipListData?.name,
						website:
							membershipListData?.website ||
							`${membershipListData?.name
								?.toLowerCase()
								.replace(/\s/g, '')}.com`,
						email: membershipListData?.contactEmail || 'support@sempris.com'
					})}
				</Typography>

				<Typography variant='body1' sx={{ fontWeight: 600, mb: 4 }}>
					{t('welcome', { membership: membershipListData?.name })}
				</Typography>
			</Stack>

			<OrderConfirmationTable
				membershipListData={membershipListData}
				browserResult={browserResult}
				submitResult={submitResult}
			/>
		</Box>
	);
};

OrderConfirmation.propTypes = {
	membershipListData: PropTypes.object.isRequired,
	submitResult: PropTypes.object,
	browserResult: PropTypes.object
};

export default OrderConfirmation;
